import { render, staticRenderFns } from "./PricingTariffsFeaturesSlider.vue?vue&type=template&id=7bf86742"
import script from "./PricingTariffsFeaturesSlider.vue?vue&type=script&lang=js"
export * from "./PricingTariffsFeaturesSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports